export enum AddressTypeEnum {
	Unknown = 0,
	PrimaryBillingShipping,
	PrimaryBilling,
	PrimaryShipping,
	BillingShipping,
	Billing,
	Shipping
}
